import { get } from "lodash";

export const shouldShowTransferFee = loan => Boolean(get(loan, "details.transferFee"));

export const shouldShowConditionsToTransfer = loan => Boolean(get(loan, "details.conditionsToTransfer"));
